// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1BsFZ","notes":"Notes_notes__F0_x1","note":"Notes_note__2mavw","markdown":"Notes_markdown__2luyq"};